import classNames from "@casino/external/classNames";
import getIconSize from "../getSize/getIconSize";
import type SettingsProps from "../types/SettingsProps";
import getIconHorizontalPosition from "./getIconHorizontalPosition";

const IconRight = ({ fullWidth, iconRight, size }: SettingsProps) => (
  <span
    aria-hidden="true"
    className={classNames(
      getIconSize(size),
      fullWidth &&
        `absolute block top-1/2 translate-y-[-50%] ${getIconHorizontalPosition({
          iconRight,
          size,
        })}`,
    )}
  >
    {iconRight}
  </span>
);

export default IconRight;
